import React from "react";
import filterModalStyles from "../../filterModal.module.scss";
import FilterCheckBox from "@/src/components/FilterCheckBox";
import { useFilterConditionContext } from "@/src/provider";
import { useTranslation } from "@/src/i18n/client";

const ShapeContent: React.FC = () => {
    const [shapeData, shapeSelect] = useFilterConditionContext((state) => [
        state.shapeData,
        state.shapeSelect,
    ]);
    const onChange = (id: number) => {
        shapeSelect(id);
    };
    const { t } = useTranslation("specialSub");
    return (
        <div
            className={filterModalStyles["filter-content-item"]}
            style={{ display: "block" }}
        >
            {shapeData.map((val, key) => (
                <div
                    className={filterModalStyles["filter-content-Radio"]}
                    key={key}
                >
                    <FilterCheckBox
                        title={`${t(val.title)}`}
                        id={val.id}
                        img={val.img}
                        imgW={1.22}
                        onChange={onChange}
                        checked={val.active}
                    />
                </div>
            ))}
        </div>
    );
};

export default ShapeContent;
